export enum EstadoPanelistaEnum { ACTIVO, INACTIVO, TODOS }

const idsEstadoPanelista = new Map<EstadoPanelistaEnum, string>();
idsEstadoPanelista.set(EstadoPanelistaEnum.ACTIVO, "ACTIVE");
idsEstadoPanelista.set(EstadoPanelistaEnum.INACTIVO, "INACTIVE");
idsEstadoPanelista.set(EstadoPanelistaEnum.TODOS, "TODOS");

const nombresEstadoPanelista = new Map<EstadoPanelistaEnum, string>();
nombresEstadoPanelista.set(EstadoPanelistaEnum.ACTIVO, "Activo");
nombresEstadoPanelista.set(EstadoPanelistaEnum.INACTIVO, "Inactivo");
nombresEstadoPanelista.set(EstadoPanelistaEnum.TODOS, "Todos");

export const obtenerIdEstadoPanelista: (estado: EstadoPanelistaEnum) => string =
    estado => idsEstadoPanelista.get(estado) ?? "";

export const obtenerNombresEstadoPanelista: () => Array<[EstadoPanelistaEnum, string]> =
    () => Array.from(nombresEstadoPanelista.entries());
